import { getCookieValue } from '@naturehouse/nh-essentials/lib/cookies/cookie';
import GTM from '../gtm/GTM';
import GTMExperienceImpressionModel from '../gtm/models/GTMExperienceImpressionModel';
import captureSafeException from '../util/sentry';

class ExperimentReporter {
    readonly #cookie_name = 'nh_experiments';

    public track(): void {
        const data = this.decodeCookie();
        const entries = Object.entries(data) || [];
        entries.forEach(([experimentId, variant]): void => {
            GTM.track(
                GTMExperienceImpressionModel.parseToGTMData({
                    experiment: experimentId,
                    variant: String(variant)
                })
            );
        });
    }

    public decodeCookie(): Record<string, number> {
        const cookieValue = getCookieValue(this.#cookie_name);

        if (!cookieValue) {
            return {};
        }

        const content = decodeURIComponent(cookieValue);
        try {
            return JSON.parse(content) ?? {};
        } catch (error) {
            captureSafeException(error, 'failed_json_decode_experiments_cookie', {
                cookieContent: content
            });
            return {};
        }
    }
}

export default new ExperimentReporter();
